import { Toast } from "primereact/toast"
import { useRef, useState } from "react"
import { Form } from "./Form"
import { Table } from "./Table"

export interface IEscalationType {
    id?: string,
    type_Name?: string,
    created_By?: string,
    created_At?: Date,
    updated_By?: string,
    updated_At?: Date
}

export interface IModel {
    open: boolean,
    singleData: IEscalationType
}

export const TypeMaster = () => {
    const [reLoad, setReLoad] = useState(false);
    const [modal, setModal] = useState({ singleData: { type_Name: "" }, open: false } as IModel);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: { type_Name: "" }, open: false });
    }

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} setReLoad={() => setReLoad(!reLoad)} />
            <Table setModal={setModal} toast={toast} reLoad={reLoad} />
            <Toast ref={toast} />
        </>
    );
}